<template>
  <v-app>
    <NavBar v-if="authenticated"></NavBar>
    <v-content :class="this.$router.currentRoute.name">
      <router-view/>
    </v-content>
    <Snackbar/>
    <v-fade-transition>
      <div class="transitionBG" v-show="transition"></div>
    </v-fade-transition>
    <Profile v-if="authenticated"/>
    <Bottom v-if="authenticated && this.$router.currentRoute.name == 'Dashboard'"></Bottom>
    <WoBottom v-if="authenticated && this.$router.currentRoute.name == 'Workorders'"></WoBottom>
    <SecretBottom v-if="authenticated && this.$router.currentRoute.name == 'Secret'"></SecretBottom>
  </v-app>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import Snackbar from '@/components/Snackbar.vue'
import Profile from '@/components/Profile.vue'
import { mapGetters, mapActions } from 'vuex' 
import Bottom from '@/components/Bottom.vue'
import WoBottom from '@/components/WoBottom.vue'
import SecretBottom from '@/components/SecretBottom.vue'

export default {
  name: 'App',

  data: () => ({

  }),
  components: {
    NavBar,
    Snackbar,
    Profile,
    Bottom,
    WoBottom,
    SecretBottom
  },
  computed: {
    ...mapGetters({
      authenticated: 'auth/authenticated',
      transition: 'menu/transition'
    })
  },
  methods: {
    ...mapActions({
      getData: 'data/getData'
    })
  },
  created() {
    if(this.authenticated) {
      this.getData()
    }
    if (this.$workbox) {
      this.$workbox.addEventListener("waiting", () => {
        this.showUpdateUI = true;
      });
    }
  }
};
</script>

<style lang="scss">
@font-face {
  font-family: 'Pyxel';
  src: url('~@/assets/fonts/Pyxel-SemiBold.eot');
  src: url('~@/assets/fonts/Pyxel-SemiBold.eot?#iefix') format('embedded-opentype'),
      url('~@/assets/fonts/Pyxel-SemiBold.woff2') format('woff2'),
      url('~@/assets/fonts/Pyxel-SemiBold.woff') format('woff'),
      url('~@/assets/fonts/Pyxel-SemiBold.ttf') format('truetype'),
      url('~@/assets/fonts/Pyxel-SemiBold.svg#Pyxel-SemiBold') format('svg');
  font-weight: 600;
  font-style: normal;
}
</style>

<style lang="sass">
#map
    width: 100%
    height: calc((100vh - 116px) / 2)
.v-calendar 
  .v-event
      white-space: normal!important
      height: auto!important
      width: 100%!important
      border-radius: 0!important
      margin: 0!important
.v-text-field
  &.v-text-field--enclosed
    margin: 0
    padding: 0
    border-radius: 0
.row.fill-height
  margin-top: 0
</style>